import { useQuery } from '@tanstack/react-query';
import { supervisionApi } from '../api/supervisionApi';
import { supervisionKeys } from '../queryKeys';

export function useSupervision() {
  return useQuery({
    queryKey: supervisionKeys.cards(),
    queryFn: () => supervisionApi.getSupervision(),
    staleTime: 60_000,
  });
}
